import { Component } from 'react'
import _ from "lodash";
import moment from "moment";
import { updatePayReportByProvider, getEarningsReportTotals } from "../../redux/modules/payReports";
import { getFamilyPatients, sendFamilyReport, sendReport } from '../../redux/modules/billing';
import LockHistoryModal from './lockByProviderModal'
import { generateUniqueABBR, isActiveRoles, } from "../../constants";
import "react-datepicker/dist/react-datepicker.css";
import { isBlankNullOrUndefined } from '../../utils/validations';
import Loading from '../Loading'
import BillingDetailsModal from '../BillingDetailsModal'
import ErrorModal from '../ErrorModal';
import JsonPreviewModal from "../JsonPreviewModal";
import { exportCdpCompleteReport, exportProviderRates, filterCdpWorksheetData, mergeMissingDoctorsForExport } from '../../utils/exportUtils';
import config from '../../config';
import store from 'store2';
import FloatingExportButton from './FloatingExportButton';
import ExportPreviewModal from './ExportPreviewModal';
import ProviderPayOverrideModal from './components/ProviderPayOverrideModal';
import {
    ReportFilterControls, ExcludedProvidersBar,
    ReportTableHeader, ReportTotalsRow, EmptyTableRow,
    PracticeRow, DateRow, ProviderRow,
    TotalPayConsistencyModal, CareHoverCardHost
} from './components';
import { verifyAllDentistsTotalPay, providerKey, providerLabel, removeExcludedProviders } from './services';
import FloatingVerifyButton from './FloatingVerifyButton';
import {
    applyAccountCalculations,
    canEstimateRoleFilteredPay,
    estimatePracticePay,
    filterByAltPay,
    filterByPracticeAndPositiveValues,
    filterPracticeCareByRole,
    formatCurrency,
    getOralSurgeryPractices,
    isProviderOverBase,
    getProviderBaseGroup,
    recalculateFromPractices,
    scopeRowsByPractice,
    toArray,
    groupBy,
    orderObject,
    sortPracticesByWorkedDays,
    calculateVisitsPerDay,
    initializeTotals,
    updateTotals,
    pruneData,
    practiceHasData,
    buildBaseAuditRows
} from "./services";
import { getAdjOrWriteOffbCare } from '../../utils/doctorPayHelpers';
import { withProviderDetail } from './services/providerDetail';


// Shared fallback so memoized DateRow props stay referentially stable across renders.
const EMPTY_PROCEDURES = [];

export default class CdpReportsTableByDentists extends Component {
    constructor(props) {
        super(props);
        this.state = {
            column: 'normalizedPercentageOfBillableCare',
            data: props.reportData,
            jsonPreviewData: {},
            isJsonPreviewModalOpen: false,
            jsonPreviewContext: null, // 'provider' or 'hygienist'
            jsonPreviewSelectedItem: null, // provider ABBR or hygienist name
            order: false,
            lockModal: false,
            allLockedStatus: false,
            isPayStubSummary: false,
            practicePriceList: false,
            hideColumn: {
                'lockStatus': true,
                isProgressValue: 0,
                rampStartDate: true,
                rampEndDate: true,
                // Pages embedding the report can pass column keys to start hidden (e.g. Adjustment Tracker).
                ...Object.fromEntries((props.hiddenColumns || []).map(key => [key, true]))
            },
            detailsModal: false,
            eventClick: false,
            reportDetailsData: {},
            stateHistory: [],
            showAsterisk: false,
            exportPreviewModalOpen: false,
            exportPreviewData: [],
            overrideModal: {
                open: false,
                abbr: null,
                practiceDbName: null,
                practiceName: null,
            },
            verifyTotalPayModalOpen: false,
            verifyTotalPayLoading: false,
            verifyTotalPayResults: [],
            verifyTotalPayProgress: { completed: 0, total: 0 },
            verifyTotalPayLog: []
        }
        this.dentistAbbrArr = [];
    }

    componentDidMount() {
        // Ensure UI includes any merged fallback doctors (same logic used for exports)
        const billingData = this.props.billingData || {};
        const doctorDetailsSource = billingData.doctorDetails || billingData.doctorList || null;
        const merged = mergeMissingDoctorsForExport(this.props.reportData || [], doctorDetailsSource);
        this.setState({ data: merged });
    }

    componentDidUpdate(prevProps) {
        // Recompute merged data when reportData or billingData changes
        if (prevProps.reportData !== this.props.reportData || prevProps.billingData !== this.props.billingData) {
            const billingData = this.props.billingData || {};
            const doctorDetailsSource = billingData.doctorDetails || billingData.doctorList || null;
            const merged = mergeMissingDoctorsForExport(this.props.reportData || [], doctorDetailsSource);
            this.setState({ data: merged });
        }
    }

    handleSort = (clickedColumn) => () => {
        const { column, data, order } = this.state;
        const isSameColumn = column === clickedColumn;

        this.setState({
            column: clickedColumn,
            data: isSameColumn ? data.reverse() : _.sortBy(data, [clickedColumn]),
            order: isSameColumn ? !order : true,
        });
    };

    // [V2-KEEP] S3 page: bCare / hygienist line items load first. No-op on v1.
    getData = (type, ABBR, prodAdjWo, bCare) => withProviderDetail(this.props.loadProviderDetail, ABBR, () => {
        const { data } = this.state;
        const { getPracticeName } = this.props;
        const reportDetailsData = getAdjOrWriteOffbCare(data, ABBR, getPracticeName)
        this.setState({
            detailsModal: 'report', detailsModalType: type, eventClick: 'month',
            reportDetailsData: reportDetailsData, prodAdjWo, docAbbr: ABBR,
            reportBCareTotal: bCare ?? null
        });
    })

    // [V2-KEEP] S3 page: the whole row loads first (the preview shows every field). No-op on v1.
    onClickPreviewProviderPayDetails = (data, context = 'provider', selectedItem = null) => withProviderDetail(this.props.loadProviderDetail, data, () => {
        this.setState({
            isJsonPreviewModalOpen: true,
            jsonPreviewData: data,
            jsonPreviewContext: context,
            jsonPreviewSelectedItem: selectedItem
        })
    })

    hideDetailsModal = (type) => {
        if (type !== 'production' && type !== 'adjustment' && type !== 'writeoff' && type !== 'familyView') {
            this.setState(this.state.stateHistory[0]);
        } else {
            this.setState({
                detailsModal: false, detailsModalType: false, eventClick: false,
                reportDetailsData: {}, prodAdjWo: null, docAbbr: null, practicePriceList: false
            });
        }
    }

    sortPracticesByWorkedDays = (practicesArray, doctorData) => {
        return sortPracticesByWorkedDays(practicesArray, doctorData);
    }

    savePayReportByProvider = (row, lockStatus) => {
        this.props.setLockProcessingFlag({ active: true, desc: lockStatus })
        const { dispatch } = this.props
        const { startDate, endDate } = this.props;
        const practices = row && row.data ? Object.keys(row.data) : []
        const dataObj = {
            data: row,
            abbr: row.ABBR,
            practices,
            lockStatus,
            scheduleDate: [startDate, endDate]
        }
        dispatch(updatePayReportByProvider(dataObj))
            .then(() => this.props.setLockProcessingFlag({ active: false, desc: null }))
    }
    saveAllPayReportByProvider = (_data) => {
        const { dispatch, reportData } = this.props
        const dataObj = {
            data: reportData,
            scheduleDate: moment(new Date()).format('YYYY-MM-DD'),
        }
        dispatch(updatePayReportByProvider(dataObj));
    };

    hideLockModal = () => {
        this.setState({ lockModal: false });
    }

    generateTotalsRow = (totals, hideColumn, showAsterisk, filters, indexKey, aggregatedData = {}) => {
        const {
            aggregatedWriteoffs = [],
            aggregatedAdjustments = [],
            aggregatedFinancialNotes = [],
            aggregatedPayBreakdown = [],
        } = aggregatedData;
        return (
            <ReportTotalsRow
                totals={totals}
                hideColumn={hideColumn}
                showAsterisk={showAsterisk}
                filters={filters}
                expandableColumn={this.props.expandableColumn}
                expandableRowLevel2={this.props.expandableRowLevel2}
                indexKey={indexKey}
                aggregatedWriteoffs={aggregatedWriteoffs}
                aggregatedAdjustments={aggregatedAdjustments}
                aggregatedFinancialNotes={aggregatedFinancialNotes}
                aggregatedPayBreakdown={aggregatedPayBreakdown}
                cdpPayDentist={this.props.cdpPayDentist ?? null}
                cdpPayOralSurgeon={this.props.cdpPayOralSurgeon ?? null}
                cdpPayPediatric={this.props.cdpPayPediatric ?? null}
                orthoPayTotal={this.props.orthoPayTotal ?? null}
            />
        );
    }

    getTableRows = () => {
        const totals = initializeTotals();
        const {
            reportData: propReportData, calculateBCare, getContractDetails,
            expandableColumn, getPracticeName, scheduleHours, getRTODetails, activeLock, startDate
        } = this.props;

        // Prefer merged state data (includes merged fallback doctors) so UI matches export logic
        const reportData = Array.isArray(this.state.data) && this.state.data.length ? this.state.data : (propReportData || []);

        const lockedProvidersArray = (activeLock && activeLock.abbr) ? (activeLock.abbr).split(',') : []
        let tableRows = [];
        let additionalCollectionsTableRows = [];
        // Avoid redeclaring block-scoped vars; read from this.state explicitly
        const { column, order, hideColumn, showAsterisk } = this.state;
        const { selectedDoctors = [], prodMovePractices = [], filters } = this.props;
        const orders = order ? 'asc' : 'desc';
        let filteredData = this.filterTableData(reportData);
        let sortedReportData = _.orderBy(filteredData, [column], [orders]);
        let pracHynBillableCareTotal = {};

        // Aggregated data for totals-row hover popups (Write-Offs, Adjustments, Financial Notes).
        // These arrays are populated during the forEach below and reflect the active filters.
        const aggregatedWriteoffs = [];
        const aggregatedAdjustments = [];
        const aggregatedFinancialNotes = [];
        // Pay breakdown — only qualifying UDA roles (Dentist, Oral Surgeon, Pediatric)
        const aggregatedPayBreakdown = [];
        const UDA_PAY_ROLES = ['Dentist', 'Oral Surgeon', 'Pediatric'];

        // Kept for the Base Pay badge modal, which builds its rows on demand (only when
        // opened) via getBaseAuditRows() below — not on every render.
        this.lastSortedReportData = sortedReportData;

        const _flattenRawFinancialData = (rawData, priceField, multiplicant) => {
            if (!rawData) return [];
            const src = rawData.reportData || rawData;
            const out = [];
            if (typeof src === 'object' && !Array.isArray(src)) {
                Object.values(src).forEach(practiceItems => {
                    if (Array.isArray(practiceItems)) {
                        practiceItems.forEach(item => out.push({ ...item, price: (item[priceField] || 0) * multiplicant }));
                    }
                });
            }
            return out;
        };

        if (Object.keys(sortedReportData).length) {
            let indexKey = 1;
            sortedReportData.forEach((row, rowId) => {
                pracHynBillableCareTotal[row.ABBR] = 0;
                row.totalPay = (+row.procBasedPay || 0) + (row.teamContribution || 0);
                updateTotals(totals, row);
                indexKey++;

                // --- Collect items for totals-row hover popups ---
                const providerName = row.doctorName || row.ABBR || '';
                _flattenRawFinancialData(row.dataWriteOff, 'WriteOff', -1).forEach(item =>
                    aggregatedWriteoffs.push({
                        ...item,
                        providerName,
                        practiceDisplayName: getPracticeName(item.Practice) || item.practiceName || item.Practice || '',
                    })
                );
                _flattenRawFinancialData(row.dataAdjustment, 'AdjAmt', 1).forEach(item =>
                    aggregatedAdjustments.push({
                        ...item,
                        providerName,
                        practiceDisplayName: getPracticeName(item.Practice) || item.practiceName || item.Practice || '',
                    })
                );
                if (Array.isArray(row.financialNoteList)) {
                    row.financialNoteList.forEach(note =>
                        aggregatedFinancialNotes.push({
                            ...note,
                            price: Number(note.financialNotes) || 0,
                            providerName,
                        })
                    );
                }
                // Collect pay breakdown for Total Pay popup (qualifying UDA roles only)
                if (row.role && UDA_PAY_ROLES.includes(row.role)) {
                    aggregatedPayBreakdown.push({
                        providerName,
                        role: row.role || '',
                        contractType: row.contractType || '',
                        displayBasePay: row.displayBasePay || 0,
                        procBasedPay: row.procBasedPay || 0,
                        teamContribution: row.teamContribution || 0,
                        financialNotes: row.financialNotes || 0,
                        price: row.totalPay || 0,
                    });
                }
                // -------------------------------------------------
                const key = row.ABBR;
                const levelOneIcon = this.props.expandableColumn === key ? 'minus' : 'plus';
                const doctorData = row.data;

                const isProviderLocked = lockedProvidersArray.some(p => p.toUpperCase() === (row.ABBR ?? '').toUpperCase()) ? 0 : -1
                let isRampApplicableForPractice = {};
                let isProviderOwnerOfPractice = {}
                let isCustomRates = {}, isHynContract = {};
                let HynBillableCare = 0;

                for (let practice in row.data) {
                    const currentPractice = row.data[practice];
                    if (currentPractice) {
                        // Accumulate hygienist billable care - always calculate for proper data flow
                        const practiceHygCare = parseFloat(currentPractice.hynBillableCare) || 0;
                        if (practiceHygCare > 0) {
                            HynBillableCare += practiceHygCare;
                            pracHynBillableCareTotal[row.ABBR] += practiceHygCare;
                            totals.totalHynBillableCare += practiceHygCare;
                        }
                        isRampApplicableForPractice[rowId] = isRampApplicableForPractice[rowId] || {};
                        isRampApplicableForPractice[rowId][getPracticeName(practice)] = currentPractice.isFlaggedRampApplicable['isPracticeOnRampThisMonth'];
                        isCustomRates[getPracticeName(practice)] = currentPractice.customProviderRates && currentPractice.customProviderRates.length > 0;
                        isHynContract[practice.toLowerCase()] = !!currentPractice.dataHyg;
                    }

                    if (
                        currentPractice &&
                        currentPractice.isFlaggedRampApplicable &&
                        currentPractice.isFlaggedRampApplicable.isProviderOwnerOfPractice !== undefined && currentPractice.isFlaggedRampApplicable['isProviderOwnerOfPractice']
                    ) {
                        isProviderOwnerOfPractice[rowId] = isProviderOwnerOfPractice[rowId] || {};
                        isProviderOwnerOfPractice[rowId][getPracticeName(practice)] = currentPractice.isFlaggedRampApplicable['isProviderOwnerOfPractice'];
                    }
                }
                // Store accumulated hygienist billable care only if > 0
                if (HynBillableCare > 0) {
                    pracHynBillableCareTotal[row.ABBR] = HynBillableCare;
                }

                // Store hygienist pay contribution on row for use in display and totals
                row.hygienistPayContribution = pracHynBillableCareTotal[row.ABBR] ?
                    (pracHynBillableCareTotal[row.ABBR] * ((row.payOverBase || 0) / 100)) : 0;
                totals.totalHygienistPayContribution += row.hygienistPayContribution;

                const isProdMove = (prodMovePractices || []).some(prodItem =>
                    prodItem.doctorsAbbr.includes(key.toUpperCase()) &&
                    (row.doctorPracticesArray || []).includes(prodItem.practice)
                );
                const providerQualifiesForTier = row.isProviderOnTierBonus ? '(T)' : ''
                let PerOfbillableCareHYG = 0
                if (row.procBasedPay && row.bCare && row.prodAdjWo && pracHynBillableCareTotal[row.ABBR]) {
                    PerOfbillableCareHYG = 100 * (row.procBasedPay / (row.normalizedBillableCare + row.billableNotes + (pracHynBillableCareTotal[row.ABBR] * 0.9)));
                }
                const calendarRedirectUrl = `/payandreports/cdp-pay/${moment(startDate).format('MM')}/${moment(startDate).format('YYYY')}/${row.ABBR}`
                const hansFinancialNote = row.doctorPayVariables?.someValues?.Doctors?.[0]?.doctorFinancialNoteReminders?.some(i => !i.reviewed) || false;
                const contract = this.props.contractExists &&
                    row.doctorPayVariables &&
                    row.doctorPayVariables.userId &&
                    this.props.contractExists.hasOwnProperty(row.doctorPayVariables.userId.toString()) ?
                    this.props.contractExists[row.doctorPayVariables.userId.toString()].hasContract :
                    false;
                const bcareFn = row.financialNoteList?.reduce((acc, cur) => acc + (+cur.bcare ?? 0), 0);

                tableRows.push(
                    <ProviderRow
                        key={"row " + rowId + "-level-0" + indexKey}
                        hideColumn={hideColumn}
                        row={row}
                        rowId={rowId}
                        indexKey={indexKey}
                        isProviderLocked={isProviderLocked}
                        levelOneIcon={levelOneIcon}
                        selectedDoctors={selectedDoctors}
                        expandableColumn={expandableColumn}
                        expandableRowLevel2={this.props.expandableRowLevel2}
                        isRampApplicableForPractice={isRampApplicableForPractice}
                        isProviderOwnerOfPractice={isProviderOwnerOfPractice}
                        isCustomRates={isCustomRates}
                        isHynContract={isHynContract}
                        getPracticeName={getPracticeName}
                        contract={contract}
                        hansFinancialNote={hansFinancialNote}
                        providerQualifiesForTier={providerQualifiesForTier}
                        isProdMove={isProdMove}
                        getContractDetails={getContractDetails}
                        filters={filters}
                        showAsterisk={showAsterisk}
                        PerOfbillableCareHYG={PerOfbillableCareHYG}
                        calendarRedirectUrl={calendarRedirectUrl}
                        bcareFn={bcareFn}
                        pracHynBillableCareTotal={pracHynBillableCareTotal}
                        onSaveLock={() => this.savePayReportByProvider(row, isProviderLocked >= 0)}
                        onExpandRow={() => this.props.expandRow(key)}
                        onPreviewDetails={() => {
                            const isHygienist = row.contractType === 'UKG HYN' || row.contractType === 'TMPHYN';
                            this.onClickPreviewProviderPayDetails(
                                row,
                                isHygienist ? 'hygienist' : 'provider',
                                isHygienist ? row.doctorName || row.doctorNameFromProvider : row.ABBR
                            );
                        }}
                        onSelectDoctor={(e) => this.props.handleSelectDoctor(e, row.ABBR)}
                        onExclude={this.props.showFilters ? () => this.props.excludeProvider(providerKey(row), providerLabel(row)) : undefined}
                        onGetWriteOff={() => this.getData('writeoff', row.ABBR, row.prodAdjWo)}
                        onGetAdjustment={() => this.getData('adjustment', row.ABBR, row.prodAdjWo)}
                        onGetProduction={() => this.getData('production', row.ABBR, row.prodAdjWo, row.bCare)}
                        futureRates={this.props.futureProviderRates?.[row.doctorId]}
                        currentRates={this.props.providerRates?.[row.doctorId]}
                    />
                )

                if (key === expandableColumn) {
                    if (row.data && Object.keys(row.data)) {
                        let indexKey2 = 1;
                        const sortedPractices = sortPracticesByWorkedDays(Object.keys(row.data), row.data)
                            .filter(practice => practiceHasData(row.data[practice]));
                        sortedPractices.forEach((practice, i) => {
                            indexKey2++;
                            let practiceDataUnordered = doctorData[practice].data;
                            const practiceData = orderObject(practiceDataUnordered);
                            const practiceCare = doctorData[practice].price;
                            const patientVisits = doctorData[practice].patientVisits;
                            const workedDaysExt = row.data[practice].worked || 0;
                            const pracHynContract = !!doctorData[practice].dataHyg;
                            const pracHynData = pracHynContract ? doctorData[practice].dataHyg : {};
                            const practiceAdjustment = doctorData[practice].adjustmentPrice ? doctorData[practice].adjustmentPrice : 0;
                            const practiceWriteOff = doctorData[practice].writeOffPrice;
                            const prodAdjWo = row.prodAdjWo ? row.prodAdjWo : 0;
                            const practiceBCare = calculateBCare(practiceCare, practiceAdjustment, practiceWriteOff, prodAdjWo);
                            const udaInfo = (row.data[practice]?.practiceInfo[0]?.UdaPracticeInfos) || {};
                            const rampStartDate = udaInfo && udaInfo.rampStartDate ? moment(udaInfo.rampStartDate).format('YYYY-MM-DD') : null;
                            const rampEndDate = udaInfo && udaInfo.rampEndDate ? moment(udaInfo.rampEndDate).format('YYYY-MM-DD') : null;
                            const scheduledDays = row.data[practice].scheduled;
                            const patientVisitsPerDay = workedDaysExt ? calculateVisitsPerDay(patientVisits, workedDaysExt) : '';
                            const levelTwoKey = row.ABBR + practice;
                            const bPCV = patientVisits !== 0 ? (practiceBCare + parseFloat(row.data[practice].billableNotes)) / patientVisits : 0;
                            const customProviderRates = doctorData[practice].customProviderRates && doctorData[practice].customProviderRates.length > 0;
                            let levelTwoIcon = 'plus'
                            let isRampApplicable = row.data[practice].isFlaggedRampApplicable;
                            const practiceHynBillCare = row.data[practice].hynBillableCare ? row.data[practice].hynBillableCare : 0;
                            if (this.props.expandableRowLevel2 === levelTwoKey) {
                                levelTwoIcon = 'minus';
                            }
                            let practiceName = getPracticeName(practice);
                            if (!practiceName || practiceName.length <= 1 || practiceName === 'Not found')
                                practiceName = practice;
                            const { rtoApproved, rtoForced } = getRTODetails(row.ABBR ? row.doctorName : '', practiceName);
                            const payMonthKey = this.props.startDate ? this.props.startDate.slice(0, 7) : null;
                            const liveOverrides = this.props.providerPayOverrides || [];
                            const hasLiveOverride = payMonthKey ? liveOverrides.some(
                                o => o.abbr === row.ABBR && o.practice_db_name === practice && o.pay_month === payMonthKey && o.force_bcare_pay
                            ) : false;
                            const hasPayOverride = !!(row.data[practice] && row.data[practice].hasOverride) || hasLiveOverride;
                            tableRows.push(
                                <PracticeRow
                                    key={"row " + rowId + i + "-level-1" + indexKey + "" + indexKey2}
                                    hideColumn={hideColumn}
                                    row={row}
                                    practice={practice}
                                    practiceName={practiceName}
                                    expandableRowLevel2={this.props.expandableRowLevel2}
                                    showAsterisk={showAsterisk}
                                    workedDaysExt={workedDaysExt}
                                    scheduledDays={scheduledDays}
                                    rtoApproved={rtoApproved}
                                    rtoForced={rtoForced}
                                    patientVisits={patientVisits}
                                    bPCV={bPCV}
                                    patientVisitsPerDay={patientVisitsPerDay}
                                    rampStartDate={rampStartDate}
                                    rampEndDate={rampEndDate}
                                    practiceCare={practiceCare}
                                    practiceWriteOff={practiceWriteOff}
                                    practiceAdjustment={practiceAdjustment}
                                    prodAdjWo={prodAdjWo}
                                    practiceBCare={practiceBCare}
                                    practiceHynBillCare={practiceHynBillCare}
                                    levelTwoIcon={levelTwoIcon}
                                    levelTwoKey={levelTwoKey}
                                    customProviderRates={customProviderRates}
                                    pracHynContract={pracHynContract}
                                    isRampApplicable={isRampApplicable}
                                    expandRowLevelTwo={this.props.expandRowLevelTwo}
                                    hasPayOverride={hasPayOverride}
                                    onOpenOverride={() => this.setState({
                                        overrideModal: {
                                            open: true,
                                            deleteMode: false,
                                            abbr: row.ABBR,
                                            practiceDbName: practice,
                                            practiceName
                                        }
                                    })}
                                    onDeleteOverride={() => this.setState({
                                        overrideModal: {
                                            open: true,
                                            deleteMode: true,
                                            abbr: row.ABBR,
                                            practiceDbName: practice,
                                            practiceName
                                        }
                                    })}
                                    enableBcareOverride={this.props.filters?.enableBcareOverride}
                                    highlightBaseStatus={this.props.filters?.highlightBaseStatus}
                                />
                            );

                            if (levelTwoKey === this.props.expandableRowLevel2) {
                                if (practiceData && Object.keys(practiceData)) {
                                    let indexKey3 = 1;
                                    Object.keys(practiceData).forEach((date, index) => {
                                        indexKey3++;
                                        const patientVisits = practiceData[date].patientVisits;
                                        const DayProcFee = practiceData[date].price;
                                        const dayProcedures = practiceData[date].procedures || EMPTY_PROCEDURES;
                                        let dateAdjustment = practiceData[date].adjustmentPrice;
                                        let dateWriteOff = practiceData[date].writeOffPrice;
                                        const practiceName = (getPracticeName(practice) || practice || '').toLowerCase();
                                        const startEnd = scheduleHours[practiceName] ? scheduleHours[practiceName].filter(shift => (moment(shift.startDate).utc().format('YYYY-MM-DD') === date) && (shift.abbr.toLowerCase().includes(row.ABBR.toLowerCase()))) : [];
                                        const practiceDayBCare = practiceData[date].billableCare || 0;
                                        const practiceHynBCare = (pracHynData[date] && pracHynData[date].billableCare) || 0;
                                        const bPCV = patientVisits !== 0 ?
                                            (practiceDayBCare + parseFloat(practiceData[date].billableNotes)) / patientVisits : 0;
                                        let dayTotalHynCollections = 0;
                                        if (row.data[practice].dataHyg && row.contractType === 'Collections w/HYN') {
                                            const rowDataHyn = row.data[practice].dataHyg;
                                            const hygArr = generateUniqueABBR(Object.keys(rowDataHyn));
                                            hygArr.forEach((abbr) => {
                                                const currHygKey = abbr + "_" + date;
                                                dayTotalHynCollections += rowDataHyn[currHygKey] ? rowDataHyn[currHygKey].Amount : 0;
                                            });
                                        }

                                        tableRows.push(
                                            <DateRow
                                                key={"row " + rowId + i + index + "-level-2" + indexKey + "" + indexKey2 + "" + indexKey3}
                                                hideColumn={hideColumn}
                                                row={row}
                                                practice={practice}
                                                showAsterisk={showAsterisk}
                                                date={date}
                                                patientVisits={patientVisits}
                                                DayProcFee={DayProcFee}
                                                dayProcedures={dayProcedures}
                                                dateAdjustment={dateAdjustment}
                                                dateWriteOff={dateWriteOff}
                                                startEnd={startEnd}
                                                practiceDayBCare={practiceDayBCare}
                                                practiceHynBCare={practiceHynBCare}
                                                bPCV={bPCV}
                                                dayTotalHynCollections={dayTotalHynCollections}
                                                prodAdjWo={prodAdjWo}
                                                practiceData={practiceData}
                                            />
                                        )
                                    })
                                    //  Iterate over the sumCollectionsTotalByDate[practice] to show this missing collection values ;
                                    if (row.data[practice].sumCollectionsTotalByDate && (row.contractType === 'Collections' || row.contractType === 'Collections w/HYN')) {
                                        for (let date in row.data[practice].sumCollectionsTotalByDate) {
                                            const [doctorAbb, dateWithoutPractice] = date.split('_');
                                            if (!practiceData[dateWithoutPractice] && doctorAbb === row.ABBR) {
                                                let tableRow = (
                                                    <tr key={"row " + rowId + "-level-3-" + date}>
                                                        <td className={"expandedLevelOneBackground"}>{''}</td>
                                                        <td className={"expandedLevelOneBackground"}>{''}</td>
                                                        <td className={"expandedLevelOneBackground"}>{''}</td>
                                                        <td className={"expandedLevelOneBackground"}>{''}</td>
                                                        <td className={"expandedLevelOneBackground"}>{''}</td>
                                                        <td className={"expandedLevelOneBackground"}>{''}</td>
                                                        <td className={"expandedLevelOneBackground"}>{''}</td>
                                                        <td className={"expandedLevelOneBackground"}>{''}</td>
                                                        <td className={"expandedLevelOneBackground"}>{''}</td>
                                                        <td className={"expandedLevelOneBackground"}>{''}</td>
                                                        <td className={"expandedLevelOneBackground"}>{''}</td>
                                                        <td className={"expandedLevelOneBackground"}>{''}</td>
                                                        <td className={"expandedLevelOneBackground"}>{''}</td>
                                                        <td className={"expandedLevelOneBackground"}>{''}</td>
                                                        <td className={"expandedLevelOneBackground"}>{''}</td>
                                                        <td className={"expandedLevelOneBackground"}>{''}</td>
                                                        <td className={"expandedLevelOneBackground"}>{dateWithoutPractice}</td>
                                                        <td className={"expandedLevelOneBackground"}>{''}</td>
                                                        <td className={"expandedLevelOneBackground"}>{''}</td>
                                                        <td className={"expandedLevelOneBackground"}>{''}</td>
                                                        <td className={"expandedLevelOneBackground"}>{''}</td>
                                                        <td className={"expandedLevelOneBackground"}>{''}</td>
                                                        <td className={"expandedLevelOneBackground"}>{formatCurrency(row.data[practice].sumCollectionsTotalByDate[date].Amount)}</td>
                                                        <td className={"expandedLevelOneBackground"}>{''}</td>
                                                        <td className={"expandedLevelOneBackground"}>{''}</td>
                                                    </tr>
                                                );
                                                additionalCollectionsTableRows.push(tableRow);
                                            }
                                        }
                                    }
                                }
                            }
                        })
                        // Add the additional table rows to the main table rows.
                        tableRows = tableRows.concat(additionalCollectionsTableRows);
                    }
                }
            });

            if (filters.excludeAccount && filters.excludeAccount.length > 0) {
                totals.totalBillableCare = (this._filteredBeforeAccount || []).reduce(
                    (acc, row) => acc + (parseFloat(row?.bCare || 0) || 0),
                    0
                );
                totals.grandtotalBasePay = (this._filteredBeforeAccount || []).reduce(
                    (acc, row) => acc + (parseFloat(row?.displayBasePay || 0) || 0),
                    0
                );
            }

            tableRows.push(this.generateTotalsRow(totals, hideColumn, showAsterisk, filters, indexKey, {
                aggregatedWriteoffs,
                aggregatedAdjustments,
                aggregatedFinancialNotes,
                aggregatedPayBreakdown,
            }));
            // One entry per provider; tableRows also holds expanded practice/day sub-rows, which must not inflate the counts.
            const totalProviders = sortedReportData.length;
            this.props.updateHeaderLabel(totalProviders);
            this.props.updateBasePerc(totals.dentistAbbrArr.length > 0 ? (totals.baseDentists.length + "/" + totals.dentistAbbrArr.length) + "=" + ((totals.baseDentists.length / totals.dentistAbbrArr.length * 100).toFixed(0)) : 0);
            this.props.updateCustomContractPerc(totalProviders > 0 ? (totals.customContractTotal + "/" + totalProviders) + "=" + ((totals.customContractTotal / totalProviders * 100).toFixed(0)) : 0);
        } else {
            tableRows.push(<EmptyTableRow />);
            this.props.updateHeaderLabel(0);
            this.props.updateBasePerc(0);
            this.props.updateCustomContractPerc(0);
        }
        const allLockedStatus = totals.lockCount.indexOf(false) === -1;
        this.dentistAbbrArr = totals.dentistAbbrArr;
        return { tableRows, allLockedStatus };
    }

    // On-demand only — called when the Base Pay badge modal is opened, not on every render.
    getBaseAuditRows = () => buildBaseAuditRows(this.lastSortedReportData || [], this.props.getDoctorFullName, this.props.getPracticeName);

    filterPayType = (data) => {
        const { payType } = this.props.filters;
        if (payType === null) return pruneData(data);
        const filteredData = data.filter(el => isProviderOverBase(el, payType));
        return pruneData(filteredData);
    }

    filterWorkedHalfDay = (data) => {
        const { scheduleHours, getPracticeName } = this.props;
        const FOUR_HOURS_MS = 4 * 60 * 60 * 1000;

        return data.reduce((acc, provider) => {
            const practiceData = provider?.data || {};
            const providerAbbr = (provider.ABBR || '').toLowerCase();

            const filteredPractices = Object.entries(practiceData).reduce((practiceAcc, [practiceKey, practice]) => {
                const dailyData = practice?.data || {};
                const practiceName = (getPracticeName(practiceKey) || practiceKey || '').toLowerCase();
                const shifts = scheduleHours?.[practiceName] || [];

                const filteredDays = Object.entries(dailyData).reduce((dayAcc, [dayKey, day]) => {
                    const dayShifts = shifts.filter(shift =>
                        moment(shift.startDate).utc().format('YYYY-MM-DD') === dayKey &&
                        shift.abbr.toLowerCase().includes(providerAbbr)
                    );
                    if (dayShifts.length > 0) {
                        const duration = parseInt(dayShifts[0].end, 10) - parseInt(dayShifts[0].start, 10);
                        if (duration > 0 && duration <= FOUR_HOURS_MS) {
                            dayAcc[dayKey] = day;
                        }
                    }
                    return dayAcc;
                }, {});

                if (Object.keys(filteredDays).length > 0) {
                    practiceAcc[practiceKey] = { ...practice, data: filteredDays };
                }
                return practiceAcc;
            }, {});

            if (Object.keys(filteredPractices).length > 0) {
                acc.push({ ...provider, data: filteredPractices });
            }
            return acc;
        }, []);
    }

    filterDaysType = (data) => {
        const { daysType } = this.props.filters;

        return (data || []).filter(({ data: practiceData = {} }) => {
            const values = Object.values(practiceData);
            // Providers with no practice data have nothing to compare, so they are neither Match nor Non-Match.
            return values.length > 0 && values.every(({ worked, scheduled }) => worked === scheduled) === !!daysType;
        });
    }

    // "Other Practice Making Base": base-pay contract with a configured Base Pay, worked at more
    // than one practice, with a mix of over-base and not-over-base practices.
    isOtherPracticeMakingBase = (item) => {
        if (!getProviderBaseGroup(item.contractType) || !(item.displayBasePay > 0)) return false;
        const workedPractices = Object.values(item.data || {}).filter(p => (p.worked || 0) > 0);
        if (workedPractices.length <= 1) return false;
        const hasAboveBase = workedPractices.some(p => p.isPracticeOverBase === true);
        const hasBelowBase = workedPractices.some(p => p.isPracticeOverBase === false);
        return hasAboveBase && hasBelowBase;
    };

    filterTableData = (data) => {
        if (!data || data.length === 0) {
            return [];
        }
        const { filters, calculateBCare, getPracticeFilterKey, getRegionFilterKeys } = this.props;

        let filteredData = removeExcludedProviders(data || [], this.props.excludedProviders)
            .filter(filterByAltPay)
            .filter(filterByPracticeAndPositiveValues);

        // Brand/Practice scoping below narrows each row's data to the selected practices, which would
        // leave one worked practice and make "Other Practice Making Base" match nothing. Decide it on
        // the full, unscoped provider instead.
        const brandScoped = !!toArray(filters?.brandName) && !toArray(filters.brandName).includes('All');
        const practiceScoped = !!toArray(filters?.practiceName);
        const regionScoped = !!toArray(filters?.region);
        const otherPracticeBaseAbbrs = filters.otherPracticeMakingBase && (brandScoped || practiceScoped || regionScoped)
            ? new Set(filteredData.filter(this.isOtherPracticeMakingBase).map(item => item.ABBR))
            : null;

        const brandArr = toArray(filters?.brandName);
        if (brandArr && !brandArr.includes('All')) {
            // Brand is a practice-level attribute — scope totals to only the doctor's
            // practices in the selected brand(s), not just their doctor-wide presence.
            filteredData = scopeRowsByPractice(filteredData, calculateBCare, (practiceKey, practiceObj) => {
                const brand = practiceObj?.practiceInfo?.[0]?.UdaPracticeInfos?.brand;
                return brandArr.includes(brand);
            });
        }

        const practiceArr = toArray(filters?.practiceName);
        if (practiceArr) {
            // The raw key in item.data is the DB practice name and the dropdown option values are
            // DB names too; getPracticeFilterKey normalises the key to the practice-list DB name
            // (keys can occasionally be the display name) so both sides compare on the same identity.
            const selectedKeys = new Set(practiceArr.map(p => String(p || '').toLowerCase()));
            filteredData = scopeRowsByPractice(filteredData, calculateBCare, (practiceKey) =>
                selectedKeys.has(getPracticeFilterKey(practiceKey)));
        }

        if (filters.notesReminder !== null && filters.notesReminder !== undefined) {
            filteredData = filteredData.filter(item => {
                const reminders = item.doctorPayVariables?.someValues?.Doctors?.[0]?.doctorFinancialNoteReminders;
                return filters.notesReminder ? reminders?.some(i => !i.reviewed) : !reminders || reminders.every(i => i.reviewed);
            });
        }

        const supportUserFilter = filters?.supportUser;
        if (supportUserFilter === '__not_defined__') {
            filteredData = filteredData.filter(item => {
                const supportUserId = item.doctorPayVariables?.someValues?.Doctors?.[0]?.supportUserId;
                return supportUserId === null || supportUserId === undefined;
            });
        } else {
            const supportUserArr = toArray(supportUserFilter);
            if (supportUserArr && !supportUserArr.includes('all')) {
                filteredData = filteredData.filter(item => {
                    const supportUserId = item.doctorPayVariables?.someValues?.Doctors?.[0]?.supportUserId;
                    return supportUserArr.includes(supportUserId);
                });
            }
        }

        const dentistArr = toArray(filters?.dentist);
        if (dentistArr) {
            filteredData = filteredData.filter(item => dentistArr.includes(item.doctorId));
        }

        const contractArr = toArray(filters?.contractType);
        if (contractArr) {
            const hasTier = contractArr.includes('Tier');
            const contractTypes = contractArr.filter(c => c !== 'Tier').map(c => (typeof c === 'string' ? c.trim().toLowerCase() : c));
            const matchesContract = (itemType) => {
                const typeLower = itemType?.toLowerCase() || '';
                return contractTypes.some(type => type === 'w/hyn' ? typeLower.includes('w/hyn') : typeLower === type);
            };

            if (hasTier && contractTypes.length === 0) {
                filteredData = filteredData.filter(item => item.isProviderOnTierBonus === true);
            } else if (hasTier) {
                filteredData = filteredData.filter(item => matchesContract(item.contractType) || item.isProviderOnTierBonus === true);
            } else {
                filteredData = filteredData.filter(item => matchesContract(item.contractType));
            }
        }

        if (filters.customContract !== null && filters.customContract !== undefined) {
            if (filters.customContract === 'all') {
                filteredData = filteredData.filter(item => !!item.customContract);
            } else if (filters.customContract === 'no_scissor') {
                filteredData = filteredData.filter(item => !item.customContract);
            } else if (filters.customContract === 'red_scissor') {
                filteredData = filteredData.filter(item => {
                    if (!item.customContract) return false;
                    const isReviewed = item.doctorPayVariables?.someValues?.Doctors?.[0]?.doctorCustomContracts?.[0]?.reviewed;
                    return !isReviewed;
                });
            } else if (filters.customContract === 'green_scissor') {
                filteredData = filteredData.filter(item => {
                    if (!item.customContract) return false;
                    const isReviewed = item.doctorPayVariables?.someValues?.Doctors?.[0]?.doctorCustomContracts?.[0]?.reviewed;
                    return !!isReviewed;
                });
            }
        }

        const greaterOfCategoryArr = toArray(filters?.greaterOfCategory);
        if (greaterOfCategoryArr && greaterOfCategoryArr.length > 0) {
            const includesNotDefined = greaterOfCategoryArr.includes('not_defined');
            const otherCategories = greaterOfCategoryArr.filter(c => c !== 'not_defined');
            filteredData = filteredData.filter(item =>
                (includesNotDefined && !item.greater_of_category) ||
                otherCategories.includes(item.greater_of_category)
            );
        }

        const roleArr = toArray(filters?.role);
        if (roleArr) {
            const { scheduleHours, getPracticeName, calculateBCare } = this.props;
            const filterIncludesOralSurgeon = roleArr.includes('Oral Surgeon');
            const filterIncludesDentist = roleArr.includes('Dentist');
            // Single-role selection (the common case) is strict and day-accurate: only
            // Dentist/Oral-Surgeon *days* (per schedule speciality) count toward bCare.
            // Selecting both roles together falls back to the older whole-practice logic below.
            const targetRole = filterIncludesDentist && !filterIncludesOralSurgeon
                ? 'Dentist'
                : (filterIncludesOralSurgeon && !filterIncludesDentist ? 'Oral Surgeon' : null);
            // Pediatric days a Dentist/Oral Surgeon row worked count too when Pediatric is also selected,
            // so the combined selection is the union of the roles rather than just the first one.
            const targetRoles = targetRole
                ? [targetRole, ...(roleArr.includes('Pediatric') ? ['Pediatric'] : [])]
                : null;

            if (targetRole && scheduleHours) {
                filteredData = filteredData.reduce((acc, item) => {
                    const directMatch = roleArr.includes(item.role);
                    // Rows of another selected role (Pediatric, Hygienists) are not narrowed by the
                    // Dentist/Oral Surgeon day logic — they'd end up with 0 worked / 0 scheduled days.
                    if (directMatch && item.role !== 'Dentist' && item.role !== 'Oral Surgeon') {
                        acc.push(item);
                        return acc;
                    }
                    // Only Dentist rows can cross into the Oral Surgeon filter (covering OS shifts);
                    // there's no modeled crossover the other way.
                    const canCrossover = targetRole === 'Oral Surgeon' && item.role === 'Dentist';
                    if (!directMatch && !canCrossover) return acc;
                    if (!item.data) return acc;

                    const providerAbbr = (item.ABBR || '').toLowerCase();
                    const narrowedData = {};
                    let hasQualifyingDay = false;

                    Object.keys(item.data).forEach(practiceKey => {
                        const practiceNameLower = (getPracticeName(practiceKey) || practiceKey || '').toLowerCase();
                        const shifts = scheduleHours[practiceNameLower] || [];
                        const filtered = filterPracticeCareByRole(item.data[practiceKey], shifts, providerAbbr, targetRoles);
                        if (filtered === null) return; // no shift data at all for this practice — exclude it
                        // recalculateFromPractices rolls up bCare from practiceBcare (a stored,
                        // whole-period field), not from price/adjustment/writeOff, so it must be
                        // recomputed here to reflect the narrowed days too.
                        filtered.practiceBcare = calculateBCare(filtered.price, filtered.adjustmentPrice, filtered.writeOffPrice, item.prodAdjWo || 0);
                        narrowedData[practiceKey] = filtered;
                        if (Object.keys(filtered.data || {}).length > 0) hasQualifyingDay = true;
                    });

                    if (Object.keys(narrowedData).length === 0) return acc;
                    // Crossover rows only make sense if they actually have qualifying days.
                    if (!directMatch && !hasQualifyingDay) return acc;

                    // Re-imagine pay from the narrowed bCare/days-worked where we can do so
                    // accurately (see rolePayEstimate.js for exactly which contracts/configs
                    // are supported); everything else keeps the whole-period pay figure.
                    const canEstimatePay = canEstimateRoleFilteredPay(item);
                    if (canEstimatePay) {
                        Object.values(narrowedData).forEach(practice => {
                            const { dailyRateBasedPay, basePay } = estimatePracticePay(
                                practice.practiceBcare, practice.practicePayOverBase, practice.practiceDailyRatePay, practice.worked
                            );
                            practice.practicePayBasedOnDailyRate = dailyRateBasedPay;
                            practice.practiceTotalPay = basePay;
                            practice.basePayNotDayFiltered = false;
                            practice.payEstimated = true;
                        });
                    }

                    const recalculated = recalculateFromPractices(item, narrowedData, calculateBCare);
                    if (canEstimatePay) {
                        // recalculateFromPractices preserves the original displayBasePay when no
                        // practices were dropped — override it here since we now have a real
                        // narrowed total to show instead.
                        recalculated.displayBasePay = recalculated.totalBasePay;
                    }
                    acc.push({
                        ...recalculated,
                        data: narrowedData,
                        doctorPracticesArray: Object.keys(narrowedData),
                        roleBCareFiltered: true,
                        payEstimated: canEstimatePay,
                    });
                    return acc;
                }, []);
            } else if ((filterIncludesOralSurgeon || filterIncludesDentist) && scheduleHours) {
                filteredData = filteredData.reduce((acc, item) => {
                    const directMatch = roleArr.includes(item.role);

                    if (directMatch) {
                        // Dentist-only filter: exclude oral surgery practices
                        if (item.role === 'Dentist' && filterIncludesDentist && !filterIncludesOralSurgeon && item.data) {
                            const osPractices = getOralSurgeryPractices(item, scheduleHours, getPracticeName);
                            if (osPractices.length > 0) {
                                const remaining = {};
                                Object.keys(item.data).forEach(p => {
                                    if (!osPractices.includes(p)) {
                                        remaining[p] = item.data[p];
                                    }
                                });
                                if (Object.keys(remaining).length > 0) {
                                    const recalculated = recalculateFromPractices(item, remaining, calculateBCare);
                                    acc.push({ ...recalculated, data: remaining, doctorPracticesArray: Object.keys(remaining) });
                                }
                                return acc;
                            }
                        }
                        acc.push(item);
                        return acc;
                    }

                    // Dentist provider with oral surgery shifts should appear in Oral Surgeon filter
                    if (item.role === 'Dentist' && filterIncludesOralSurgeon && item.data) {
                        const osPractices = getOralSurgeryPractices(item, scheduleHours, getPracticeName);
                        if (osPractices.length > 0) {
                            const osData = {};
                            osPractices.forEach(p => {
                                if (item.data[p]) {
                                    osData[p] = item.data[p];
                                }
                            });
                            if (Object.keys(osData).length > 0) {
                                const recalculated = recalculateFromPractices(item, osData, calculateBCare);
                                acc.push({ ...recalculated, data: osData, doctorPracticesArray: Object.keys(osData) });
                            }
                        }
                    }

                    return acc;
                }, []);
            } else {
                filteredData = filteredData.filter(item => roleArr.includes(item.role));
            }
        }

        const regionKeys = getRegionFilterKeys?.(filters?.region);
        if (regionKeys) {
            // Region is a practice-level attribute — scope totals to only the doctor's
            // practices in the selected region(s). Region expands to the practice DB names
            // in that region and is matched like the Practice filter.
            filteredData = scopeRowsByPractice(filteredData, calculateBCare, (practiceKey) =>
                regionKeys.has(getPracticeFilterKey(practiceKey)));
        }

        if (filters.isActive) {
            if (filters.isActive === 'active') {
                filteredData = filteredData.filter(item => item.isActive === "active" && isActiveRoles.includes(item.role));
            } else if (filters.isActive === "inActive") {
                filteredData = filteredData.filter(item => item.isActive === "inActive");
            }
        }

        if (filters.rampDate === true || filters.rampDate === false) {
            filteredData = this.filterRampDateData(filteredData);
        }

        if (filters.payType === true || filters.payType === false) {
            filteredData = this.filterPayType(filteredData);
        }

        if (filters.daysType === true || filters.daysType === false) {
            filteredData = this.filterDaysType(filteredData);
        }

        if (filters.lowCareByPractice) {
            filteredData = filteredData.reduce((acc, provider) => {
                const practiceData = provider?.data || {};

                const filteredPractices = Object.entries(practiceData).reduce((practiceAcc, [practiceKey, practice]) => {
                    const dailyData = practice?.data || {};

                    const filteredDays = Object.entries(dailyData).reduce((dayAcc, [dayKey, day]) => {
                        if (day?.price && day.price > 0 && day.price < 200) {
                            dayAcc[dayKey] = day;
                        }
                        return dayAcc;
                    }, {});

                    if (Object.keys(filteredDays).length > 0) {
                        practiceAcc[practiceKey] = { ...practice, data: filteredDays };
                    }
                    return practiceAcc;
                }, {});

                if (Object.keys(filteredPractices).length > 0) {
                    acc.push({ ...provider, data: filteredPractices });
                }
                return acc;
            }, []);
        }

        if (filters.workedHalfDay) {
            filteredData = this.filterWorkedHalfDay(filteredData);
        }

        const sageAccountUkg = this.props.sageAccounts?.reduce((acc, c) => {
            acc[c.accountNumber] = c.ukg;
            return acc;
        }, {});

        if (filters.otherPracticeMakingBase) {
            filteredData = filteredData.filter(item => otherPracticeBaseAbbrs
                ? otherPracticeBaseAbbrs.has(item.ABBR)
                : this.isOtherPracticeMakingBase(item));
        }

        if (filters.showLockedAtLeastOnePractice) {
            const overrides = this.props.providerPayOverrides || [];
            filteredData = filteredData.filter(item =>
                overrides.some(o =>
                    !!o.force_bcare_pay &&
                    (o.abbr || '').toUpperCase() === (item.ABBR || '').toUpperCase()
                )
            );
        }

        this._filteredBeforeAccount = filteredData;

        if (filters.excludeAccount && filters.excludeAccount.length > 0) {
            filteredData = filteredData.filter(item => {
                if (Object.keys(item.sageAccOfBillable || {}).length > 0) {
                    return !Object.values(item.data || {}).some(pracItem =>
                        pracItem && Object.keys(pracItem.financialNotesByAccount || {}).some(acc => filters.excludeAccount.includes(acc))
                    );
                }
                return !Object.keys(item.finNotesByAccount || {}).some(acc => filters.excludeAccount.includes(acc));
            });
        }

        if (filters.account && filters.account.length > 0) {
            filteredData = filteredData.filter(item => {
                if (Object.keys(item.sageAccOfBillable || {}).length > 0) {
                    return Object.values(item.data || {}).some(pracItem =>
                        pracItem && Object.keys(pracItem.financialNotesByAccount || {}).some(acc => filters.account.includes(acc))
                    );
                }
                return Object.keys(item.finNotesByAccount || {}).some(acc => filters.account.includes(acc));
            });
        }

        return filteredData.map(item => applyAccountCalculations(item, filters.account, sageAccountUkg));
    }


    componentWillUnmount = () => {
        this.props.resetFilter();
    }

    onChangeHideColumn = (e, element) => {
        let hideColumn = { ...this.state.hideColumn };
        Object.keys(hideColumn).forEach(key => {
            hideColumn[key] = element.value.includes(key);
        })
        this.setState({ hideColumn });
    }

    onSelectEvent = (event, type = 'report', eventClick = 'day') => {
        let stateObj = { detailsModal: type, detailsModalType: event.type, eventClick: eventClick, eventDate: event.id }
        if (event.price)
            stateObj.productionPrice = event.price
        if (event.type === 'familyCapacityView')
            stateObj.familyPractice = event.practice

        this.state.stateHistory = [stateObj];
        this.setState(stateObj);
        const queryParams = new URLSearchParams(window.location.search);
        const practice = queryParams.get("practice");
        const practiceName = queryParams.get("practiceName");
        const selectedPT_Num = queryParams.get("selectedPT_Num");
        if (practice && practiceName && selectedPT_Num) {
            setTimeout(() => this.openFamilyView(selectedPT_Num, practice, practiceName), 5.0 * 1000);

        }
    }

    sendReport = (detailsModalType, detailsModal, eventClick, mtdBillable, productionPrice, eventDate, startDate) => {
        const { dispatch } = this.props;
        const { docAbbr, prodAdjWo } = this.state;

        dispatch(sendReport({
            detailsModalType,
            detailsModal,
            eventClick,
            mtdBillable,
            productionPrice,
            eventDate,
            startDate,
            abbr: docAbbr,
            prodAdjWo: prodAdjWo
        }))
            .catch((err) => {
                alert('Email sending failed. Please try again.');
            });
        alert('Sending email...');
    }

    sendFamilyReport = (paramObj) => {
        const { dispatch, user } = this.props;
        const { docAbbr } = this.state;
        paramObj.abbr = docAbbr;
        paramObj.userId = user.UdaDrList.userId;
        paramObj.drName = user.UdaDrList.selectedDoctor;
        dispatch(sendFamilyReport(paramObj))
            .catch((err) => {
                alert('Email sending failed. Please try again.');
            });
        alert('Sending email...');
    }

    showPracticeList = (val) => {
        this.setState({ practicePriceList: val });
    }

    changeTab = (selectedPT_Num) => {
        if (this.state.selectedPT_Num !== selectedPT_Num)
            this.props.dispatch(this.props.getFamilyPatientDetails(selectedPT_Num, this.state.selectedPractice));
        this.setState({ 'selectedPT_Num': selectedPT_Num });
    }

    openFamilyView = (selectedPT_Num, practice, practiceName) => {
        if (this.state.selectedPT_Num !== selectedPT_Num || this.state.selectedPractice !== practice)
            this.props.dispatch(getFamilyPatients(selectedPT_Num, practice));

        const stateObj = {
            detailsModal: 'familyView',
            detailsModalType: 'familyView',
            selectedPT_Num: selectedPT_Num,
            selectedPractice: practice,
            selectedPracticeName: practiceName
        }
        if (!this.state.stateHistory[this.state.stateHistory.length - 1] ||
            this.state.stateHistory[this.state.stateHistory.length - 1].detailsModalType !== 'familyView')
            this.state.stateHistory.push(stateObj);
        this.setState(stateObj);
    }

    openNextDays = (nextDaysObj) => {
        let stateObj = { nextDaysObj: nextDaysObj, detailsModalType: 'nextDays' }

        if (this.state.stateHistory[this.state.stateHistory.length - 1].detailsModalType !== 'nextDays')
            this.state.stateHistory.push([stateObj]);
        this.setState(stateObj);
    }

    getPracticePrices = (ProdAdjWo, ABBR) => {
        const prodAdjWo = ProdAdjWo || 90;
        const { reportData } = this.props;
        const doctorData = reportData.find((doctor) => doctor.ABBR === ABBR);

        if (!doctorData) {
            return { production: {}, adjustment: {}, writeoff: {} };
        }

        const billingData = {
            production: doctorData.data || {},
            adjustment: doctorData.dataAdjustment || {},
            writeoff: doctorData.dataWriteOff || {}
        };

        const sortList = { production: {}, adjustment: {}, writeoff: {} };
        let allWriteOffs = [];

        const processPractice = (type, practice) => {
            if (practice === 'reportData') return;

            let currentBilling = billingData[type][practice];
            if (!currentBilling) return;

            if (type === 'adjustment' || type === 'writeoff') {
                const reportData = currentBilling.reportData || currentBilling;
                currentBilling = { price: 0, reportData };
            }

            if (isBlankNullOrUndefined(currentBilling.price)) return;

            if (!sortList[type][practice]) {
                sortList[type][practice] = 0;
            }
            if (!sortList.production[practice]) {
                sortList.production[practice] = 0;
            }

            if (type === 'production') {
                sortList.production[practice] += currentBilling.price;
            } else if (type === 'adjustment') {
                const adjustmentTotal = currentBilling.reportData.reduce((total, obj) => total + (obj.AdjAmt || 0), 0);
                sortList.production[practice] += adjustmentTotal;
                sortList.adjustment[practice] += adjustmentTotal;
            } else { // writeoff
                const writeOffTotal = currentBilling.reportData.reduce((total, obj) => total + (obj.WriteOff || 0), 0);
                allWriteOffs.push(...currentBilling.reportData);
                sortList.production[practice] -= writeOffTotal;
                sortList.writeoff[practice] += writeOffTotal;
            }
        };

        const types = ['production', 'adjustment', 'writeoff'];
        types.forEach(type => {
            if (billingData[type]) {
                Object.keys(billingData[type]).forEach(practice => processPractice(type, practice));
            }
        });

        const groupedWriteOffs = groupBy(allWriteOffs, 'Practice');
        sortList.writeoff = Object.entries(groupedWriteOffs).reduce((acc, [practice, items]) => {
            acc[practice] = items.reduce((sum, item) => sum + (item.WriteOff || 0), 0);
            return acc;
        }, {});

        Object.keys(sortList.production).forEach(practice => {
            sortList.production[practice] *= prodAdjWo / 100;
        });

        return sortList;
    }

    prepareExportPreviewData = () => {
        const { reportData, getDoctorFullName } = this.props;
        const billingData = this.props.billingData || {};
        const doctorDetailsSource = billingData.doctorDetails || billingData.doctorList || null;
        const cdpWorksheetData = filterCdpWorksheetData(
            mergeMissingDoctorsForExport(reportData || [], doctorDetailsSource)
        );

        const previewData = [];

        (cdpWorksheetData || []).forEach(item => {
            const providerName = item.doctorName || getDoctorFullName(item.ABBR);
            const contractType = item.contractType || '';

            // Level 1 - Provider total
            previewData.push({
                level: 1,
                provider: providerName,
                abbr: item.ABBR,
                contractType,
                practice: '',
                bcare: Number(item.bCare || 0).toFixed(3),
                procBasedPay: Number(item.procBasedPay || 0).toFixed(2)
            });

            Object.entries(item.data || {}).forEach(([practiceName, practiceObject]) => {
                const resolvedPractice = practiceObject.practiceInfo?.[0]?.practice || practiceName;

                // Level 2 - Practice total
                previewData.push({
                    level: 2,
                    provider: providerName,
                    abbr: item.ABBR,
                    contractType,
                    practice: resolvedPractice,
                    bcare: Number(practiceObject.practiceBcare || 0).toFixed(3),
                    // practiceObject.procBasedPay is not the practice's real total pay for most
                    // contract types (useRampBonus zeroes the tier bonus into it for Greater Of/
                    // Collections/GOX/GOZ, and it never includes tedCollectionsPay). practiceTotalPay
                    // is the value the practice row actually displays and that L1/L3 reconcile
                    // against, so prefer it here to avoid false recon mismatches on bonus practices.
                    procBasedPay: Number(practiceObject.practiceTotalPay ?? practiceObject.procBasedPay ?? 0).toFixed(2)
                });

                // Level 3 - Per-day rows (used for L2 vs L3 reconciliation)
                Object.entries(practiceObject.data || {}).forEach(([date, dateObject]) => {
                    previewData.push({
                        level: 3,
                        provider: providerName,
                        abbr: item.ABBR,
                        contractType,
                        practice: resolvedPractice,
                        date,
                        bcare: Number(dateObject.billableCare || 0).toFixed(3),
                        procBasedPay: Number(dateObject.totalPay || 0).toFixed(2)
                    });
                });
            });
        });

        return previewData;
    };

    showExportPreviewModal = () => {
        const previewData = this.prepareExportPreviewData();
        this.setState({
            exportPreviewModalOpen: true,
            exportPreviewData: previewData
        });
    };

    closeExportPreviewModal = () => {
        this.setState({
            exportPreviewModalOpen: false,
            exportPreviewData: []
        });
    };

    handleExport = async () => {
        this.showExportPreviewModal();
    };

    handleVerifyTotalPay = async () => {
        const { startDate, getDoctorFullName, dispatch } = this.props;
        // lastSortedReportData is set during render() and already has row.totalPay computed;
        // the raw reportData prop hasn't had totalPay assigned yet so filtering it yields nothing.
        const dentistRows = (this.lastSortedReportData || []).filter(row => row && row.ABBR);
        const total = dentistRows.length;

        this.setState({
            verifyTotalPayModalOpen: true,
            verifyTotalPayLoading: true,
            verifyTotalPayResults: [],
            verifyTotalPayProgress: { completed: 0, total },
            verifyTotalPayLog: []
        });

        try {
            const finalResults = await verifyAllDentistsTotalPay({
                rows: dentistRows,
                startDate,
                getDoctorFullName,
                fetchEarningsReportTotal: (abbr, forStartDate) => dispatch(getEarningsReportTotals(abbr, forStartDate)),
                onProgress: ({ result, completed }) => {
                    this.setState(prev => ({
                        verifyTotalPayResults: [...prev.verifyTotalPayResults, result],
                        verifyTotalPayProgress: { completed, total }
                    }));
                },
                onLog: (entry) => {
                    this.setState(prev => ({
                        verifyTotalPayLog: [...prev.verifyTotalPayLog, entry]
                    }));
                }
            });
            // Replace streamed results with the final sorted array
            this.setState({ verifyTotalPayResults: finalResults, verifyTotalPayLoading: false });
        } catch (err) {
            console.error('[handleVerifyTotalPay] failed:', err);
            this.setState({ verifyTotalPayLoading: false });
        }
    };

    closeVerifyTotalPayModal = () => {
        this.setState({ verifyTotalPayModalOpen: false });
    };

    proceedWithExport = async () => {
        try {
            const { getPracticeName, collectionDentistData, scheduleHours } = this.props;
            this.setState({ isProgressValue: 10 });
            const { reportData, startDate, endDate, getDoctorFullName } = this.props;
            let filteredData = this.filterTableData(reportData);

            // Merge in any missing doctors from doctorDetails/doctorList so exports match UI provider lists
            const billingData = this.props.billingData || {};
            const doctorDetailsSource = billingData.doctorDetails || billingData.doctorList || null;
            const cdpWorksheetSource = mergeMissingDoctorsForExport(reportData || [], doctorDetailsSource);
            
            filteredData = mergeMissingDoctorsForExport(filteredData, doctorDetailsSource);
            // The merge can re-add providers that were excluded from the view
            filteredData = removeExcludedProviders(filteredData, this.props.excludedProviders);
            this.setState({ isProgressValue: 30 });

            // Ensure providers have a top-level adpId where possible (backfill from nested doctor objects or doctorDetails)
            try {
                const missingBefore = (filteredData || []).filter(fd => !fd || !(fd.adpId || fd.ukgid)).length;
                (filteredData || []).forEach(fd => {
                    try {
                        if (!fd) return;
                        if (!fd.adpId || String(fd.adpId).trim() === '') {
                            // check nested doctorPayVariables -> someValues -> Doctors[0]
                            const nested = fd.doctorPayVariables && fd.doctorPayVariables.someValues && fd.doctorPayVariables.someValues.Doctors && fd.doctorPayVariables.someValues.Doctors[0];
                            const nestedAdp = nested && (nested.adpId || (nested.someValues && nested.someValues.adpId));
                            if (nestedAdp) {
                                fd.adpId = nestedAdp;
                                return;
                            }

                            // fallback: try billingData doctorDetails source
                            if (doctorDetailsSource) {
                                let srcDoc = null;
                                if (Array.isArray(doctorDetailsSource)) {
                                    srcDoc = doctorDetailsSource.find(d => (d && ((d.abbr || d.ABBR) && String(d.abbr || d.ABBR).toUpperCase()) === (fd.ABBR || '').toUpperCase()));
                                } else if (typeof doctorDetailsSource === 'object') {
                                    srcDoc = doctorDetailsSource[(fd.ABBR || '').toUpperCase()];
                                }
                                const srcAdp = srcDoc && (srcDoc.adpId || (srcDoc.someValues && srcDoc.someValues.adpId));
                                if (srcAdp) fd.adpId = srcAdp;
                            }
                        }
                    } catch (e) { }
                });
                const missingAfter = (filteredData || []).filter(fd => !fd || !(fd.adpId || fd.ukgid)).length;
                try { console.log('[CDP-EXPORT-DEBUG] proceedWithExport - adpId missing before/after', missingBefore, missingAfter); } catch (e) { }
            } catch (e) { console.warn('[CDP-EXPORT-DEBUG] proceedWithExport - adpId backfill failed', e); }

            // If many providers are missing companyCode, request them from the server
            try {
                const missingProviders = (filteredData || []).filter(d => (!d.companyCode || String(d.companyCode).trim() === '') && (d.ukgid || d.adpId));
                if (missingProviders.length > 0) {
                    const ukgIds = Array.from(new Set(missingProviders.map(d => d.ukgid).filter(Boolean)));
                    const adpIds = Array.from(new Set(missingProviders.map(d => d.adpId).filter(Boolean)));
                    try {
                        const url = `${config.apiHost.replace(/\/$/, '')}/reports/api/getCompanyCodes`;
                        const myHeaders = new Headers();
                        myHeaders.append('Content-Type', 'application/json');
                        const token = store('authToken');
                        if (token) myHeaders.append('Authorization', `Bearer ${token}`);
                        const resp = await fetch(url, {
                            method: 'POST',
                            headers: myHeaders,
                            credentials: 'same-origin',
                            body: JSON.stringify({ ukgIds, adpIds })
                        });
                        if (resp && resp.ok) {
                            const map = await resp.json();
                            (filteredData || []).forEach(fd => {
                                if (!fd.companyCode || String(fd.companyCode).trim() === '') {
                                    const adpKey = fd.adpId ? `adp:${fd.adpId}` : null;
                                    const ukgKey = fd.ukgid ? `ukg:${fd.ukgid}` : null;
                                    if (adpKey && map[adpKey]) fd.companyCode = map[adpKey];
                                    else if (ukgKey && map[ukgKey]) fd.companyCode = map[ukgKey];
                                }
                            });} else {}
                    } catch (e) {}
                }
            } catch (e) { console.warn('[CDP-EXPORT-DEBUG] proceedWithExport - companyCode patching failed', e); }

            // Payroll-facing sheets use the UI-filtered dataset; the master CDP
            // worksheet receives the full merged month so hygienists are not dropped.
            await exportCdpCompleteReport(
                filteredData,
                collectionDentistData,
                scheduleHours,
                startDate,
                endDate,
                getDoctorFullName,
                { getPracticeName, providerRates: exportProviderRates(this.props), cdpWorksheetSource }
            );

            this.setState({ isProgressValue: 100 });
            this.closeExportPreviewModal();

            // Reset progress after a delay
            setTimeout(() => {
                this.setState({ isProgressValue: 0 });
            }, 1000);

        } catch (error) {
            console.error('Export failed:', error);
            this.setState({ isProgressValue: 0 });
        }
    };

    getSageAccountsWithTotals = () => {
        const { sageAccounts } = this.props;
        if (!sageAccounts || sageAccounts.length === 0) return [];
        const reportData = this._filteredBeforeAccount || this.state.data || this.props.reportData || [];
        const accountTotals = {};
        reportData.forEach(item => {
            if (Array.isArray(item.financialNoteList)) {
                item.financialNoteList.forEach(note => {
                    const acc = note.sageAccount;
                    const amount = Number(note.financialNotes) || 0;
                    if (acc && amount !== 0) {
                        accountTotals[acc] = (accountTotals[acc] || 0) + amount;
                    }
                });
            }
        });
        const formatCurrency = (val) => {
            const abs = Math.abs(val).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            return val < 0 ? `-$${abs}` : `$${abs}`;
        };
        return sageAccounts
            .filter(acc => accountTotals[acc.accountNumber] !== undefined)
            .map(acc => ({
                ...acc,
                text: `${acc.accountNumber} - ${formatCurrency(accountTotals[acc.accountNumber])} - ${acc.accountDescription}`
            }));
    };

    render() {
        const { isLoad, loadErr, loadErrFamily, isNextDaysLoad, lockProcessingFlag, showFilters, futureProviderRates, providerRates } = this.props;
        const { detailsModal, detailsModalType, docAbbr, prodAdjWo, reportDetailsData } = this.state;
        const allPracticePrices = !isBlankNullOrUndefined(docAbbr) ? this.getPracticePrices(prodAdjWo, docAbbr) : {};
        // Built once per render (it used to run twice: header lock status + body rows).
        const tableModel = this.getTableRows();

        const excludedProvidersControl = (
            <ExcludedProvidersBar
                reportData={this.props.reportData}
                excludedProviders={this.props.excludedProviders}
                onChange={this.props.setExcludedProviders}
                lastExcluded={this.props.lastExcludedProvider}
                onUndo={this.props.undoLastExcludedProvider}
            />
        );

        return (
            <div>
                {isLoad || isNextDaysLoad ? <Loading /> : ''}
                {(loadErr || loadErrFamily) &&
                    <ErrorModal hideDetailsModal={this.hideErrorModal} errorMessage={loadErr || loadErrFamily} />
                }
                <div>
                    {!showFilters && (this.props.excludedProviders || []).length > 0 && excludedProvidersControl}
                    {showFilters && (
                        <ReportFilterControls
                            excludedProvidersControl={excludedProvidersControl}
                            contractNameOptions={this.props.contractNameOptions}
                            dentistOptions={this.props.dentistOptions}
                            regionListOptions={this.props.regionListOptions}
                            practiceOptions={this.props.practiceOptions}
                            isActiveOptions={this.props.isActiveOptions}
                            brandOptions={this.props.brandOptions}
                            supportUserOptions={this.props.supportUserOptions}
                            rampDateOptions={this.props.rampDateOptions}
                            sageAccounts={this.getSageAccountsWithTotals()}
                            filters={this.props.filters}
                            hideColumn={this.state.hideColumn}
                            showAsterisk={this.state.showAsterisk}
                            onChangeFilter={this.props.onChangeFilter}
                            onChangeHideColumn={this.onChangeHideColumn}
                            onToggleAsterisk={() => this.setState({ showAsterisk: !this.state.showAsterisk })}
                            reportData={this.filterTableData(this.state.data || this.props.reportData)}
                            getPracticeName={this.props.getPracticeName}
                            scheduleHours={this.props.scheduleHours}
                            collectionDentistData={this.props.collectionDentistData}
                            getDoctorFullName={this.props.getDoctorFullName}
                        />
                    )}
                </div>
                <div className="table-responsive tableFixHeadAndFirstTwoColumn">
                    {lockProcessingFlag.active && <Loading desc={'Processing..'} />}
                    {this.state.isJsonPreviewModalOpen && <JsonPreviewModal
                        jsonData={this.state.jsonPreviewData}
                        isOpen={this.state.isJsonPreviewModalOpen}
                        context={this.state.jsonPreviewContext}
                        selectedItem={this.state.jsonPreviewSelectedItem}
                        onClose={() => this.setState({
                            isJsonPreviewModalOpen: false,
                            jsonPreviewContext: null,
                            jsonPreviewSelectedItem: null
                        })}
                    />}
                    <CareHoverCardHost />
                    <table className="table-fixed table-striped table-hover show-active-sort">
                        <ReportTableHeader
                            column={this.state.column}
                            order={this.state.order}
                            hideColumn={this.state.hideColumn}
                            expandableColumn={this.props.expandableColumn}
                            expandableRowLevel2={this.props.expandableRowLevel2}
                            handleSort={this.handleSort}
                            handleSelectAll={this.props.handleSelectAll}
                            dentistAbbrArr={this.dentistAbbrArr}
                            allLockedStatus={tableModel.allLockedStatus || this.state.allLockedStatus}
                            saveAllPayReportByProvider={this.saveAllPayReportByProvider}
                        />
                        <tbody>
                            {this.state.lockModal && <LockHistoryModal
                                hideLockModal={this.hideLockModal}

                            />}
                            {tableModel.tableRows}
                        </tbody>
                    </table>
                </div>

                {(detailsModal) && <BillingDetailsModal
                    {...this.props}
                    {...this.state}
                    hideDetailsModal={this.hideDetailsModal}
                    onSelectEvent={this.onSelectEvent}
                    sendReport={this.sendReport}
                    sendFamilyReport={this.sendFamilyReport}
                    reportData={reportDetailsData}
                    allPracticePrices={allPracticePrices[detailsModalType]}
                    showPracticeList={this.showPracticeList}
                    openFamilyView={this.openFamilyView}
                    changeTab={this.changeTab}
                    openNextDays={this.openNextDays}
                />}

                <ExportPreviewModal
                    open={this.state.exportPreviewModalOpen}
                    onClose={this.closeExportPreviewModal}
                    exportPreviewData={this.state.exportPreviewData}
                    isProgressValue={this.state.isProgressValue}
                    onProceedExport={this.proceedWithExport}
                />

                <FloatingExportButton
                    isProgressValue={this.state.isProgressValue}
                    onClick={this.handleExport}
                />

                <FloatingVerifyButton
                    loading={this.state.verifyTotalPayLoading}
                    onClick={this.handleVerifyTotalPay}
                />

                <TotalPayConsistencyModal
                    open={this.state.verifyTotalPayModalOpen}
                    loading={this.state.verifyTotalPayLoading}
                    results={this.state.verifyTotalPayResults}
                    progress={this.state.verifyTotalPayProgress}
                    log={this.state.verifyTotalPayLog}
                    onClose={this.closeVerifyTotalPayModal}
                />

                {this.state.overrideModal.open && (() => {
                    const { abbr, practiceDbName, practiceName, deleteMode } = this.state.overrideModal;
                    const payMonth = this.props.startDate
                        ? this.props.startDate.slice(0, 7)
                        : null;
                    const overrides = this.props.providerPayOverrides || [];
                    const existing = overrides.find(
                        o => o.abbr === abbr
                          && o.practice_db_name === practiceDbName
                          && o.pay_month === payMonth
                    ) || null;
                    return (
                        <ProviderPayOverrideModal
                            open
                            abbr={abbr}
                            practiceDbName={practiceDbName}
                            practiceName={practiceName}
                            payMonth={payMonth}
                            existingOverride={existing}
                            deleteMode={!!deleteMode}
                            onClose={() => this.setState({ overrideModal: { open: false, abbr: null, practiceDbName: null, practiceName: null, deleteMode: false } })}
                            onSave={this.props.onSaveProviderPayOverride}
                            onDelete={this.props.onDeleteProviderPayOverride}
                            onDeleteByKey={this.props.onDeleteProviderPayOverrideByKey}
                        />
                    );
                })()}
            </div>
        );
    }
}
